export default __webpack_public_path__ + "static/media/check-mark.48622f68.svg";